import React, { useState, useEffect } from 'react';
import { useAuth } from '../services/AuthContext';
import { supabase } from '../services/supabase/supabase-config';
import { Helmet } from 'react-helmet-async';

import { buscarVersaoAtual } from '../services/downloads';
import { podeBaixarPlugin } from '../utils/statusLicenca';
import UserInfo from '../components/dashboard/UserInfo';
import SubscriptionCard from '../components/dashboard/SubscriptionCard';
import DownloadCard from '../components/dashboard/DownloadCard';
import Alert from '../components/ui/Alert';

const DashboardPage = () => {
  const { user } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [versao, setVersao] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSubscriptionData = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      setLoading(true);
      setError('');
      try {
        // Um usuário acumula linhas em subscriptions: o trial mais cada compra.
        // Vale a de vencimento mais distante. Usar single() aqui daria erro assim
        // que existisse a segunda linha, então é order + limit.
        const { data, error: subError } = await supabase
          .from('subscriptions')
          .select('*, plans(*)')
          .eq('user_id', user.id)
          .in('status', ['active', 'past_due'])
          .order('current_period_end', { ascending: false })
          .limit(1);

        if (subError) throw subError;

        setSubscription(data?.[0] ?? null);
        setVersao(await buscarVersaoAtual());
      } catch (err) {
        console.error('Erro ao buscar dados da assinatura:', err);
        setError('Não foi possível carregar os dados da sua assinatura.');
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionData();
  }, [user]);


  const podeBaixar = podeBaixarPlugin(subscription);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[60vh]">
        <p className="text-rn-text-soft">Carregando informações da sua conta...</p>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>Dashboard - RNPlugin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="bg-rn-bg min-h-[calc(100vh-4rem)]">
        <div className="container mx-auto px-6 py-12">
          <div className="mb-8">
            <h1 className="text-[27px] md:text-[32px] font-semibold text-rn-navy">
              Painel do Cliente
            </h1>
          </div>

          {error && <Alert type="error" message={error} className="mb-8" />}

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2 space-y-8">
              <UserInfo subscription={subscription} />
            </div>

            <div className="space-y-8">
              <SubscriptionCard subscription={subscription} />
              <DownloadCard versao={versao} podeBaixar={podeBaixar} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardPage;
